/**
 * Shows ⚡ 30 min on product cards when tags + user city qualify (express + city_* match, or explicit 30min tags).
 */
import { getDeliveryType } from './skipp-product-delivery-type.js';
import { isLocationEnforcementSatisfied } from './skipp-location-preference.js';

const EXPRESS_LABEL_HTML = `<svg class="delivery-badge__icon" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="#FFD54F" d="M13 2 3 14h8l-1 8 10-12h-8l1-8z"/></svg><span class="delivery-badge__text">30 min</span>`;

function findTagsHost(el) {
  let host = null;
  let node = el.parentElement;
  while (node) {
    if (node.hasAttribute?.('data-skipp-tags')) host = node;
    node = node.parentElement;
  }
  return host;
}

function applyBadge(el, isExpress) {
  if (isExpress) {
    el.hidden = false;
    el.innerHTML = EXPRESS_LABEL_HTML;
    el.classList.add('skipp-delivery-badge--express');
    el.classList.remove('skipp-delivery-badge--next');
  } else {
    el.hidden = true;
    el.innerHTML = '';
    el.classList.remove('skipp-delivery-badge--express', 'skipp-delivery-badge--next');
  }
}

export function refreshSkippDeliveryBadges(root = document) {
  if (!isLocationEnforcementSatisfied()) {
    root.querySelectorAll('[data-skipp-delivery-badge]').forEach((el) => {
      el.hidden = true;
    });
    return;
  }

  const city = window.SkippUserLocation?.getUserLocation?.()?.city || '';

  root.querySelectorAll('[data-skipp-delivery-badge]').forEach((el) => {
    const host = findTagsHost(el);
    if (!host) {
      el.hidden = true;
      return;
    }
    const raw = host.getAttribute('data-skipp-tags') || '';
    const isExpress = getDeliveryType({ tags: raw }, city) === 'express';
    applyBadge(el, isExpress);
  });
}

function debounce(fn, ms) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), ms);
  };
}

const refreshDebounced = debounce(() => refreshSkippDeliveryBadges(), 120);

function observeDynamicCards() {
  if (typeof MutationObserver === 'undefined') return;
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (!m.addedNodes?.length) continue;
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('[data-skipp-delivery-badge], [data-skipp-tags]') ||
          node.querySelector?.('[data-skipp-delivery-badge]')
        ) {
          refreshDebounced();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function init() {
  refreshSkippDeliveryBadges();
  observeDynamicCards();

  document.addEventListener('skipp:user-location-changed', () => refreshSkippDeliveryBadges());
  document.addEventListener('skipp:location-api-ready', () => refreshSkippDeliveryBadges());
  document.addEventListener('skipp:location-preference-changed', () => refreshSkippDeliveryBadges());
  document.addEventListener('shopify:section:load', (ev) => {
    if (ev.target) refreshSkippDeliveryBadges(ev.target);
  });
}

if (typeof window !== 'undefined') {
  window.refreshSkippDeliveryBadges = refreshSkippDeliveryBadges;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
